import React, { useState } from 'react';
import {
  Box,
  Button,
  Grid,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
  useTheme,
} from '@mui/material';
import { tokens } from '../../theme';
import { useTranslation } from '../../hooks/useTranslation';

const MAIN_FIELDS = ['value', 'nature', 'creditorName', 'occurrenceDate', 'state'];

function formatCurrency(value) {
  if (!value) return '-';
  const number = parseFloat(value) / 100;
  if (isNaN(number)) return '-';
  return `R$ ${number.toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
}

const FinancialPendenciesTable = ({ details = [] }) => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);
  const { t } = useTranslation();
  const [expanded, setExpanded] = useState(null);

  if (!details || details.length === 0) return null;

  return (
    <TableContainer
      component={Paper}
      variant="outlined"
      sx={{ backgroundColor: colors.primary[400], borderRadius: 2 }}
    >
      <Table size="small">
        <TableHead sx={{ backgroundColor: colors.greenAccent[400] }}>
          <TableRow>
            {[
              t('consultation.fpValue'),
              t('consultation.fpNature'),
              t('consultation.fpCreditor'),
              t('consultation.fpDate'),
              t('consultation.fpState'),
              t('consultation.fpMore'),
            ].map((label) => (
              <TableCell key={label} sx={{ color: colors.grey[900], fontWeight: 600 }}>
                {label}
              </TableCell>
            ))}
          </TableRow>
        </TableHead>
        <TableBody>
          {details.map((detail, i) => (
            <React.Fragment key={i}>
              <TableRow>
                <TableCell>{formatCurrency(detail.value)}</TableCell>
                <TableCell>{detail.nature || '-'}</TableCell>
                <TableCell>{detail.creditorName || '-'}</TableCell>
                <TableCell>{detail.occurrenceDate?.replace(/-/g, '/') || '-'}</TableCell>
                <TableCell>{detail.state || '-'}</TableCell>
                <TableCell>
                  <Button
                    size="small"
                    variant="contained"
                    sx={{
                      backgroundColor: colors.greenAccent[600],
                      color: colors.grey[900],
                      '&:hover': { backgroundColor: colors.greenAccent[400] },
                    }}
                    onClick={() => setExpanded(expanded === i ? null : i)}
                  >
                    {expanded === i ? t('consultation.hide') : t('consultation.verMore')}
                  </Button>
                </TableCell>
              </TableRow>

              {expanded === i && (
                <TableRow>
                  <TableCell colSpan={6}>
                    <Box sx={{ padding: 2, backgroundColor: colors.grey[800], borderRadius: 2 }}>
                      <Grid container spacing={2}>
                        {Object.entries(detail).map(([key, value]) =>
                          value !== null &&
                          value !== undefined &&
                          value !== '' &&
                          !MAIN_FIELDS.includes(key) ? (
                            <Grid item xs={12} sm={6} key={key}>
                              <Typography fontSize={14} color={colors.grey[100]}>
                                <strong>{t(`fieldLabels.${key}`, key)}:</strong>{' '}
                                {key.toLowerCase().includes('date')
                                  ? String(value).replace(/-/g, '/')
                                  : String(value)}
                              </Typography>
                            </Grid>
                          ) : null
                        )}
                      </Grid>
                    </Box>
                  </TableCell>
                </TableRow>
              )}
            </React.Fragment>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
};

export default FinancialPendenciesTable;
